import React, { Component } from 'react';
import { connect } from 'react-redux';
import { hashHistory } from 'react-router';
import NavigatorMain from '../NavigatorMain';

class WebView extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }
  componentWillMount(){
    document.title = this.props.location.state.title
  }
  next(){
    console.log(this.props.location.state.route,window.history.length)
    hashHistory.go(-1)
    setTimeout(()=>{
      this.props.location.state.refreshPage ? this.props.location.state.refreshPage() : null;
    },100)
  }
  render(){
    let _this=this;
    console.log(this.props.location)
    return (
        <div className="container" >
          <NavigatorMain>
          <div className="header black">
            <div onClick={hashHistory.goBack}><span className="headerLeftBtn"></span></div>
            <div>{this.props.location.state.title}</div>
            <div></div>
          </div>
          </NavigatorMain>

            <div className='content' >
              <div className='share'>
                <div className='shareTitle' style={{color:'#5b6370',fontSize:'.26rem'}}>
                  {this.props.location.state.content}
                </div>
              </div>
              <div className='question_suc_box'>
                <div style={{width:'100%'}}>
                  {
                    this.props.location.state.dataSouse.map(function (item,i) {
                      return(
                        <div key={'cq'+i} className='question_suc_item'>
                          <p style={{fontSize:"0.32rem",WebkitFlex:1,color:'#3a3e47'}}>{item[0]}</p>
                          <p style={{color:'rgba(130,138,138,1)',WebkitFlex:1,textAlign:'right'}}>{item[1]}</p>
                        </div>
                      )
                    })
                  }
                </div>
               
              </div>
              {this.props.location.state.tipVal!=''||this.props.location.state.tipVal!=undefined?
              <div className='question_suc_tip'>
                  <p style={{color:'#5b6370'}}>风险提示：</p>
                  <p style={{fontSize:'.24rem',color:'#a1a7b2'}}>{this.props.location.state.tipVal}</p>
              </div>
              :null
              }
              
              
              <div onClick={()=>this.next()} className='btn'>
                我已知晓
              </div>
            </div>
        </div>
    );
  }
}


function mapStateToProps(state, ownProps) {
  return {
    
  }
}
export default connect(mapStateToProps)(WebView);



// WEBPACK FOOTER //
// ./src/components/pubQuestion/FinishQuestionnaireSuccess.js